import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { ServicePlanItemPricingPolicy } from 'src/features/servicePlanPricingPolicies/utils/types';

const RESOURCE = '/subscriptions/service-plan-item/:servicePlanItemId/service-plan-item-pricing-policy/:pricingPolicyId/';

type QueryFnType = typeof queryFn;

interface DTO {
    servicePlanItemId: string;
    pricingPolicyId: string;
}
const queryFn = ({ servicePlanItemId, pricingPolicyId }: DTO): Promise<ServicePlanItemPricingPolicy> => {
    return axios.get(formatResourcePath(RESOURCE, { servicePlanItemId, pricingPolicyId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetServicePlanPricingPolicy,  RESOURCE as SERVICE_PLAN_PRICING_POLICY_RESOURCE };
